export default __webpack_public_path__ + "static/media/confirm-add-to-contact.3008e5df.svg";